import createImageUrlBuilder from "@sanity/image-url";
import type { SanityImageSource } from "@sanity/image-url/lib/types/types";
import type { ReactNode } from "react";
import { isValidElement } from "react";

export type { SanityImageSource } from "@sanity/asset-utils";
export { getImageDimensions } from "@sanity/asset-utils";

export const getSanityImageUrl = (source: SanityImageSource, projectId: string, dataset: string) =>
  createImageUrlBuilder({ projectId, dataset }).image(source);

export const wrapTextNodes = (children: ReactNode) => {
  if (Array.isArray(children)) {
    return (children as ReactNode[]).map((child, index) =>
      // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
      typeof child === "string" ? <span key={index}>{child}</span> : child,
    );
  }
  if (typeof children === "string") {
    return <span>{children}</span>;
  }
  if (isValidElement(children)) {
    return children;
  }
  return null;
};
